<!-- @format -->
<div class="dialog-max cdialog" style="width: 50vw; height: 80vh">
  <div class="dialogHeader">
    <h2 mat-dialog-title>{{_common.door_log}}</h2>
    <div class="spacer"></div>

    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>
  </div>

  <mat-dialog-content class="margin_top max-height">
    <app-access-log-list [device]="object" [location]="location"></app-access-log-list>
  </mat-dialog-content>
  <!-- <div align="end" class="dialogBar">
    <button class="app-btn" (click)="save()" color="primary">
      {{_common.confirm}}
    </button>
  </div> -->
</div>